export { Analytics } from './core/analytics';
export { AnalyticsBrowser, } from './browser';
export * from './node';
export * from './core/context';
export * from './core/events';
export * from './core/plugin';
export * from './core/user';
export { getGlobalAnalytics } from './lib/global-analytics-helper';
export { UniversalStorage } from './core/storage';
export { segmentio } from './plugins/segmentio';
export { resolveAliasArguments, resolveArguments, resolvePageArguments, resolveUserArguments, } from './core/arguments-resolver';
//# sourceMappingURL=index.js.map